<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <form class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('feed.detail_publish') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body">
            <div class="slideshow-container" v-if="detail.files?.length > 0">
              <div v-for="(file, index) in detail.files" :key="index">
                <div v-if="currentIndex === index" class="mySlides">
                  <div class="numbertext">{{ index + 1 }} / {{ detail.files?.length }}</div>
                  <template v-if="isImage(file.file_url)">
                    <img :src="file.file_url" class="full-image" :alt="file.file">
                  </template>
                  <template v-else>
                    <iframe :src="file.file_url" :alt="file.file" frameborder="0" class="file-iframe" allowfullscreen></iframe>
                  </template>
                </div>
              </div>

              <a class="prev" @click="changeSlide(-1)">&#10094;</a>
              <a class="next" @click="changeSlide(1)">&#10095;</a>
            </div>

            <br>

            <div v-if="detail.files?.length > 0" style="text-align:center">
              <span v-for="(file, index) in detail.files" :key="index" class="dot" :class="{ active: currentIndex === index }" @click="setSlide(index)"></span>
            </div>

            <div class="card my-5 mx-2" style="border: 2px solid var(--bs-gray-200)">
              <div class="card-header border-0">
                <div class="d-flex align-items-center">
                  <div class="me-2">
                    <ManyAvatar :size="1" :data="user"/>
                  </div>
                  <div>
                    <div class="d-flex align-items-center">
                      <h2 class="me-3">{{detail?.publisher?.name}}</h2>
                    </div>
                    <span>{{ format(detail?.created_at) }}</span>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <h3 class="mb-2">{{detail.title}}</h3>
                <div v-html="detail?.content"></div>
                <div class="d-flex justify-content-end mt-3">
                  <span>{{ detail?.comments_count }} {{ $t('feed.comments') }}</span>
                </div>
              </div>
              <div class="card-footer">
                <div class="d-flex justify-content-between align-items-center">
                  <span @click="show = !show" style="cursor: pointer;"><i class="fas fa-comments fs-2 me-2"></i>{{ $t('feed.comment') }}</span>
                  <div class="d-flex">
                    <div v-if="detail.reactions" class="d-flex dropdown">
                      <div v-for="(emoji, index) in detail.reactions" :title="$t('button.view')" data-bs-toggle="dropdown" aria-expanded="false" style="cursor: pointer;"
                          :key="index"
                          v-html="index" 
                          class="fs-2 me-2"
                      >
                      </div>
                      <ul class="dropdown-menu dropdown-menu-end shadow" style="max-height: 400px; overflow-y: auto; width: 250px;">
                            <li>
                                <span class="px-5 d-flex justify-content-between">
                                    <div class="d-flex" v-for="(emoji, index) in detail.reactions" :key="index">
                                        <span class="me-2 mt-1">{{ emoji?.count }}</span>
                                        <span v-html="index" class="fs-2"></span>
                                    </div>
                                </span>
                            </li>
                            <li v-for="(user, index) in detail.user_reactions" :key="index">
                                <span class="px-5 d-flex justify-content-between">
                                    <span>{{ user?.name }}</span>
                                    <span v-html="user?.type" class="fs-2"></span>
                                </span>
                            </li>
                      </ul>
                    </div>
                    <div class="d-flex justify-content-center align-items-center card shadow-sm px-2" style="width: 30px; height: 30px;">
                        
                        <div class="dropdown" :title="$t('feed.react')">
                            <div data-bs-toggle="dropdown" aria-expanded="false" style="cursor: pointer;">
                                <i class="fas fa-smile text-yellow fs-2"></i>
                            </div>
                            <ul class="dropdown-menu dropdown-menu-end shadow">
                                <li>
                                    <a class="dropdown-item" href="#">
                                        <span class="me-3 fs-2" :title="emoji[locale]" @click="selectDetailEmoji(emoji.value)" v-for="(emoji, index) in emojis" :key="index" v-html="emoji.value"></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="detail.mentions?.length > 0" class="d-flex justify-content-center align-items-center card shadow-sm px-2 ms-3" style="width: 30px; height: 30px;">
                        <div :title="$t('feed.mentions')" data-bs-toggle="dropdown" aria-expanded="false" style="cursor: pointer;">
                            <i class="fas fa-users fs-2"></i>
                        </div>
                        <ul class="dropdown-menu dropdown-menu-end shadow mt-2" style="max-height: 300px; overflow-y: auto; width: 150px;">
                            <li v-for="(user, index) in detail.mentions" :key="index">
                                <span class="px-5">
                                    {{ user?.name }}
                                </span>
                            </li>
                        </ul>
                    </div>
                  </div>
                </div>
                <div v-if="show" class="border-top pt-5 mt-5">
                    <Comment :detail="detail" :emojis="emojis" :project="project" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script setup>
  import {computed, ref, onMounted} from "vue";
  import ManyAvatar from "@/components/ManyAvatar";
  import Comment from "../components/Comment.vue"
  import {formatDistance} from "date-fns";
  import {fr} from "date-fns/locale";
  import {useLocales} from "@/composables/locales";
  import {useStore} from "vuex";

  const props = defineProps({
      id: {
        type: String,
        required: true
      },
      detail: {
        type: Object,
        default: {}
      },
      emojis: {
        type: Array,
        default: []
      },
      project: {
          type: Object,
          default: {}
      }
  })

  const store = useStore()
  const show  = ref(false)
  const nowDate = ref(new Date())
  const {locale} = useLocales()
  const currentIndex = ref(0);
  const user = computed(() => {
      let fullname = props.detail?.publisher?.name?.split(' ')
      return fullname ? [{firstname: fullname[0], lastname: fullname[1]}] : []
  })

  function format(date){
      return date ? formatDistance(new Date(date), nowDate.value, { locale: fr}) : ''
  }

  function selectDetailEmoji(item) {
    store.dispatch('feeds/createFeedReaction', {type: item, model: "PUBLICATION", model_id: props.detail?.id})
  }

  function closeModal(){
    $('#'+props.id).modal('toggle')
  }

  function isImage(url) {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
  }

  const changeSlide = (n) => {
    if (!props.detail.files || props.detail.files.length === 0) return;
    currentIndex.value = (currentIndex.value + n + props.detail.files.length) % props.detail.files.length;
  }

  const setSlide = (index) => {
    currentIndex.value = index;
  };

  onMounted(() => {
    currentIndex.value = 0;
  })
</script>

<style scoped>
  .full-image, .file-iframe {
      width: 100%;
      height: 400px;
      object-fit: cover;
      border-radius: 4px;
  }

  .text-yellow {
      color: var(--bs-yellow) !important;
  }

  * { box-sizing: border-box; }

.slideshow-container {
  max-width: 1000px;
  position: relative;
  margin: auto;
  height: 400px;
}

.mySlides {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block !important;
}

.mySlides img {
  width: 100%;
}

.prev, .next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  margin-top: -22px;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
  background-color: rgba(0,0,0,0.8);
}

.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}

.numbertext {
  color: black;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active, .dot:hover {
  background-color: #717171;
}
</style>